export default __webpack_public_path__ + "static/media/haris.0ce4d515.jpg";